"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logMissingStatsigUserWarning = exports.isNoopClient = exports.isPrecomputedEvalClient = void 0;
const client_core_1 = require("@statsig/client-core");
function isPrecomputedEvalClient(client) {
    if (isNoopClient(client)) {
        return false;
    }
    return 'updateUserSync' in client;
}
exports.isPrecomputedEvalClient = isPrecomputedEvalClient;
function isNoopClient(client) {
    return 'isNoop' in client;
}
exports.isNoopClient = isNoopClient;
function logMissingStatsigUserWarning() {
    client_core_1.Log.warn('StatsigUser not provided for On Device Evaluation. Returning default value.');
}
exports.logMissingStatsigUserWarning = logMissingStatsigUserWarning;
